<template>
  <div>
    <a-modal :open="showPopup" :onCancel="handleCancel" :footer="false" wrap-class-name="full-modal" width="100%" >
      <!-- <template #title>
        <slot name="top"></slot>
      </template>
      <template #footer>
        <h-button key="back" @click="handleCancel">{{ $t('text.cancel') }}</h-button>
        <h-button
          key="submit"
          type="primary"
          @click="handleOk"
          >{{ $t('text.ok') }}</h-button
        >
      </template> -->
      <div>
        <slot name="content"></slot>
      </div>
    </a-modal>
  </div>
</template>
<script lang="ts" setup>
import { ref } from "vue";
const emits = defineEmits(["closePopup", "submitPopup"])
interface props {
  showPopup: any;
}
const propsData = withDefaults(defineProps<props>(), {
  showPopup: false,
});

const handleOk = () => {
  emits('submitPopup', true)
};

const handleCancel = () => {
  emits('closePopup', false)
};
</script>
